import React from "react";
import { useParams } from "react-router-dom";
import projects from "./ProjectData";

function LayoutMap() {
  const { id } = useParams();
  const project = projects.find(p => p.id === parseInt(id));

  if (!project) return <h2>Project Not Found</h2>;

  return (
    <div className="container mt-5 text-center">

      <h2 className="mb-4">{project.title} - Layout Plan</h2>

      <img
        src={project.layout}
        alt=""
        className="img-fluid shadow rounded"
      />

    </div>
  );
}

export default LayoutMap;